import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { RouterOutletWrapperComponent } from '../../../shared/components/router-outlet-wrapper';
import { PdpInquiryModalModule } from '../components/pdp-inquiry-modal/pdp-inquiry-modal.module';
import { PdpListVariantsModalModule } from '../components/pdp-list-variants-modal/pdp-list-variants-modal.module';
import { SampleOrderModalModule } from '../components/sample-order-modal/sample-order-modal.module';
import { AddonRedirectGuard } from '../guards/addon-redirect.guard';
import { CatalogGuard } from '../guards/catalog.guard';
import { PdpGuard } from '../guards/pdp.guard';
import { RedirectGuard } from '../guards/redirect.guard';
import { ShortProductRedirectGuard } from '../guards/short-product-redirect.guard';
import { GetArticleResolver, LeafCategoryCodeResolver, ProductCodeResolver, RestoreScrollPositionResolver } from './resolvers';

const cmsConfig: CmsConfig = {
  cmsComponents: {
    CmsBrowseCatalogFlexComponent: {
      component: RouterOutletWrapperComponent,
      childRoutes: {
        children: [
          {
            path: 'addons/:title',
            loadChildren: () => import('./addons/addons.module').then((m) => m.AddonsModule),
          },
          {
            path: ':productName/print',
            loadChildren: () =>
              import('../components/print-product-articles/print-product-articles.module').then(
                (m) => m.PrintProductArticlesModule
              ),
            resolve: {
              productCode: ProductCodeResolver,
            },
          },
          {
            matcher: (segments, _group, _route) => {
              const match = segments.every((segment) => !segment.path.includes('--p'));
              if (match) {
                const posParams = {};
                segments.forEach((segment, index) => (posParams[`categoryName${index + 1}`] = segment));
                return { consumed: segments, posParams };
              }
              return null;
            },
            canActivate: [CatalogGuard],
            loadChildren: () => import('./catalog/catalog.module').then((m) => m.CatalogModule),
            runGuardsAndResolvers: 'always',
            resolve: { restoreScrollPosition: RestoreScrollPositionResolver, categoryCode: LeafCategoryCodeResolver },
          },
          {
            matcher: (segments, _group, _route) => {
              const match = segments.some((segment) => segment.path.includes('--p'));

              if (match) {
                const posParams = {};
                segments.forEach((segment, index) => {
                  let key = `categoryName${index + 1}`;
                  if (segment.path.includes('--p')) {
                    key = 'productName';
                  }
                  posParams[key] = segment;
                });
                return { consumed: segments, posParams };
              }
              return null;
            },
            canActivate: [PdpGuard],
            loadChildren: () => import('./pdp/pdp.module').then((m) => m.PdpModule),
            runGuardsAndResolvers: 'always',
            resolve: {
              article: GetArticleResolver,
              categoryCode: LeafCategoryCodeResolver,
              productCode: ProductCodeResolver,
            },
          },
        ],
      },
    },
    CmsCatalogFlexComponent: {
      component: RouterOutletWrapperComponent,
      childRoutes: {
        children: [
          {
            path: 'addons/:title',
            canActivate: [AddonRedirectGuard],
            loadChildren: () => import('./redirect/redirect.module').then((m) => m.RedirectModule),
          },
          {
            path: 'product/:articleCode',
            canActivate: [ShortProductRedirectGuard],
            loadChildren: () => import('./redirect/redirect.module').then((m) => m.RedirectModule),
          },
          {
            path: '**',
            canActivate: [RedirectGuard],
            loadChildren: () => import('./redirect/redirect.module').then((m) => m.RedirectModule),
            runGuardsAndResolvers: 'always',
          },
        ],
      },
    },
  },
};

@NgModule({
  imports: [PdpListVariantsModalModule, SampleOrderModalModule, PdpInquiryModalModule, ConfigModule.withConfig(cmsConfig)],
})
export class CmsCatalogPdpModule {}
